/* eslint-disable no-undef */
import axios from 'axios'
import {clearOutput} from '../../utils/general'

function cancelar (output) {
  output.outputWatson.json_response.push(
    output.contexto._cita.cancela)
  return clearOutput(output, '_cita')
}

function error (output) {
  output.outputWatson.json_response.push(
    output.contexto._cita.fallido)
  return clearOutput(output, '_cita')
}

export let citas = {
  async init ({output}) {
    let flag = false
    try {
      var ans = await axios.get(window.civiiConf.backavit +
        '/avit/vehiculo/usuarioSesion')
    } catch (e) { return error(output) }

    if (ans.status === $CONSTANTES.HttpStatus.OK) flag = true

    if (!flag) {
      output.input = 'Conductores'
      output = await citas.tramites({output})
      return output
    }

    output.contexto.vehiculos_data = ans.data
    output.outputWatson.json_response.push(
      output.contexto._cita.conductores_o_vehiculos)
    output.outputWatson.buttons = ['Vehículos', 'Conductores', 'Cancelar']
    output.outputWatson.disableInput = true
    output.contexto.actions.before = ['citas.tramites']
    return output
  },
  async tramites ({output}) {
    let tramiteId

    if (output.input === 'Vehículos') {
      tramiteId = $CONSTANTES.TipoServicioCita.VEHICULO
      // tramiteId = 2
    } else if (output.input === 'Conductores') {
      // tramiteId = 4
      tramiteId = $CONSTANTES.TipoServicioCita.CONDUCTOR
    } else if (output.input === 'Cancelar') return cancelar(output)

    output.contexto._cita.tramiteId = tramiteId

    try {
      var ans = await axios.get(window.civiiConf.backavit +
        '/avit/citas/ConsultaTramitesPorTipoServicio/' + tramiteId)
    } catch (e) { return error(output) }

    output.outputWatson.accordion_checklist = {
      type: 'checkbox',
      blocks: [{
        title: 'Trámites',
        options: ans.data.map(
          (el) => ({label: el.nombreTramite, value: el.idTramite}))
      }]
    }
    output.outputWatson.disableInput = true
    output.outputWatson.json_response.push(
      output.contexto._cita.tramites)
    output.contexto.actions.before = ['citas.validar_cita']
    return output
  },
  async validar_cita ({output}) {
    if (output.contexto._input === false) return cancelar(output)

    let listIdServicio = output.contexto._input.map(el => el.value)

    try {
      var ans = await axios.post(
        window.civiiConf.backavit + '/avit/citas/validarCita', {listIdServicio})
    } catch (e) { return error(output) }

    if (ans.data) {
      output.contexto._cita.selected_tramites = listIdServicio
      try {
        var ans1 = await axios.post(
          window.civiiConf.backavit +
          '/avit/citas/ConsultaInformacionTaquillasDisponibles',
          {idTramitesSeleccionados: listIdServicio})
      } catch (e) { return error(output) }

      output.outputWatson.json_response.push(
        output.contexto._cita.sedes)

      let buttons = []
      let taqsDisp2 = {}
      for (let ptoAtencion of ans1.data) {
        if (!taqsDisp2.hasOwnProperty(ptoAtencion.idSubsede)) {
          taqsDisp2[ptoAtencion.idSubsede] = ptoAtencion
          buttons.push({
            text: ptoAtencion.nombrePuntoAtencion,
            message: String(ptoAtencion.idSubsede)
          })
        }
      }
      buttons.push('Cancelar')
      output.contexto._cita.sedes_data = taqsDisp2
      output.outputWatson.disableInput = true
      output.outputWatson.buttons = buttons
      output.contexto.actions.before = ['citas.fechas']
    } else {
      output.outputWatson.json_response.push(
        output.contexto._cita.tiene_citas)
      return clearOutput(output, '_cita')
    }
    return output
  },
  async fechas ({output}) {
    if (output.input === 'Cancelar') return cancelar(output)
    let idPuntoAtencion = parseInt(output.input)
    let payload = {
      listaGrupoTramites: output.contexto._cita.selected_tramites,
      idPuntoAtencion,
      cantidadMeses: 2
    }
    try {
      var ans = await axios.post(window.civiiConf.backavit +
        '/avit/citas/ConsultaFechasDisponibles', payload)
    } catch (e) { return error(output) }

    let date = new Date()
    let allow = {}
    for (let horario of ans.data) {
      let ndate = new Date(date.getFullYear(), date.getMonth() + horario.month)
      let nyear = ndate.getFullYear()
      let nmonth = ndate.getMonth() + 1
      if (!allow.hasOwnProperty(nyear)) allow[nyear] = {}
      allow[nyear][nmonth] = horario.days.filter(
        (v, i, a) => a.indexOf(v) === i)
    }
    output.contexto._cita.idPuntoAtencion = idPuntoAtencion
    output.contexto._cita.tiempoTotalAtencion = ans.data[0].tiempoTotalAtencion
    output.outputWatson.calendarWidget = {allow}
    output.outputWatson.disableInput = true
    output.outputWatson.json_response.push(
      output.contexto._cita.que_fecha)
    output.contexto.actions.before = ['citas.horarios']
    return output
  },
  async horarios ({output}) {
    let d = output.contexto._input

    if (d === false) return cancelar(output)

    let payload = {
      listaGrupoTramites: output.contexto._cita.selected_tramites,
      idSubsede: output.contexto._cita.idPuntoAtencion,
      fechaCita: ('0' + d.day).slice(-2) + '/' + ('0' + d.month).slice(-2) + '/' + d.year,
      tiempoTotalAtencion: output.contexto._cita.tiempoTotalAtencion
    }

    try {
      var ans = await axios.post(
        window.civiiConf.backavit + '/avit/citas/ConsultaHorasDisponibles', payload)
    } catch (e) { return error(output) }

    output.contexto._cita.fecha = d

    output.outputWatson.accordion_checklist = {
      type: 'radio',
      blocks: ans.data.map(function (horas) {
        return {
          title: horas.nombreGrupo,
          options: horas.grupoCitas.map((el) => ({
            label: el.horaInicio + ' a ' + el.horaFin,
            value: el
          }))
        }
      })
    }
    output.outputWatson.json_response.push(
      output.contexto._cita.que_hora)
    output.outputWatson.disableInput = true
    output.contexto.actions.before = ['citas.confirmar']
    return output
  },
  async confirmar ({output}) {
    let hora = output.contexto._input

    if (hora === false) return cancelar(output)

    output.contexto._cita.hora = hora.value

    let d = output.contexto._cita.fecha
    let sedesData = output.contexto._cita.sedes_data
    let ptoAtncn = output.contexto._cita.idPuntoAtencion
    output.contexto._cita.formatedFechaHora = d.day + '/' + d.month + '/' +
      d.year + ' de ' + hora.value.horaInicio + ' a ' + hora.value.horaFin
    output.contexto._cita.formatedSede = sedesData[ptoAtncn].direccionPuntoAtencion

    output.outputWatson.json_response.push(
      output.contexto._cita.confirmar)
    output.outputWatson.disableInput = true
    output.outputWatson.cancelAccept = true
    output.contexto.actions.before = ['citas.setCita']
    return output
  },
  async setCita ({output}) {
    if (output.input === 'true') {
      let payload = {
        listIdServicio: output.contexto._cita.selected_tramites,
        idPuntoAtencion: output.contexto._cita.idPuntoAtencion,
        idTipoServicio: output.contexto._cita.tramiteId,
        listControlCapacidadTaquilla: output.contexto._cita.hora.idListControlCapacidadTaquilla[0]
      }

      try {
        var ans = await axios.post(
          window.civiiConf.backavit + '/avit/citas/GuardarCitas', payload)
      } catch (e) { return error(output) }

      if (ans.data.estadoService.codigoEstado !== 1) return error(output)
      let res = ans.data

      output.outputWatson.json_response.push(
        'La cita N° ' + res.nroCita + ' fue reservada exitosamente. ¿Hay algo más en lo que pueda ayudarle?')
    } else if (output.input === 'false') {
      output.outputWatson.json_response.push(
        output.contexto._cita.cancela)
    }
    return clearOutput(output, '_cita')
  }
}

/* eslint-enable no-undef */



// WEBPACK FOOTER //
// ./src/servicios_digitales_costa/siteActions/citas.js